
const collectionName = 'clients'
const profileName = 'profiles'

export const deleteAppAdminProfileAndAuth = async (fn_cls, database_fns, dispatch, itemData, pathViews) => {
  const _refPath = [collectionName, pathViews.clients, profileName, itemData.email]
  database_fns.delete_doc(_refPath).then(res => {
    const { uid } = itemData
    c.deleteAuthByUid(uid, dispatch)
  })
}